module.exports = __webpack_public_path__ + "img/linkedin-black.598e38e9.svg";